import React, { useEffect, useState } from "react";
import LiquidContainer from '../../components/LiquidContainer';
import MainLanding from './MainLanding';
import { PERSONAL_DATA } from '../../utils/formConfig/formConfig';
import { loadValidationRules, loadDropdownData } from '../../utils/form';
import ErrorSection from '../../components/ErrorSection';
import FormRenderer from '../../components/FormRenderer';
import { useForm } from '../../hooks/useForm';
import apiClient from "../../api/apiClient";
// import pencil from '../../assets/icons/small_icons/pencil.svg'

const PersonalData = () => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    formData,
    handleChange,
    dropdowns,
    loading: dataLoading,
    errors: FormStateError,
    fieldErrors,
    isValid,
    setFormData
  } = useForm({
    initialFields: PERSONAL_DATA,
    loadDropdowns: loadDropdownData,
    loadRules: loadValidationRules
  });


useEffect(() => {
  const fetchProfile = async () => {
    try {
      const response = await apiClient.get("/profile_data/");
      const data = response.data;

      const mapped = {
        first_name: data.first_name,
        last_name: data.last_name,
        username: data.personal_email,
        personal_phone: data.personal_phone,
        birthdate: data.birthdate,
        nationality: data.nationality,
        sex: data.sex,
        passport_number: data.passport_number,
        snow_activities: data.snow_activities,
        eta: data.eta,
      };

      setFormData(prev => ({
        ...prev,
        ...mapped
      }));

    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        window.location.href = "/";
        return;
      }
      setError("Could not load profile data");
    } finally {
      setLoading(false);
    }
  };

  fetchProfile();
}, [setFormData]);;

useEffect(() => {
  // console.log("UPDATED formData:", formData);
}, [formData]);

const handleSubmit = async () => {
  try {
    await apiClient.put("/profile_data/", formData); // or patch
    alert("Profile updated successfully");
  } catch (err) {
    setError("Failed to update profile");
  }
};

  if (loading || dataLoading) return <p>Loading...</p>;
  if (FormStateError) return <p>Error loading form</p>;

  return (
    <MainLanding>
      <LiquidContainer
        backgroundColor="#efefefe0"
        ancho="85vw"
        alto="75vh"
        borderline="0px"
        boxSdw="none"
      >
        <div className='d-flex flex-column justify-content-start align-items-center py-3' style={{height: "90%",width: "90%", overflowY: "scroll", overflowX: "hidden"}}>

          <FormRenderer
            fields={PERSONAL_DATA}
            formData={formData}
            errors={fieldErrors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            dropdowns={{
              sex: dropdowns.sex_choices
            }}
            selectorMap={{ sex: "Género" }}
            showToplabel={true}
          />

          <ErrorSection error={error} errors={fieldErrors} />

        </div>
      </LiquidContainer>
    </MainLanding>
  );
};

export default PersonalData;